import { CompleteProfileInvitationForm } from "../types/forms/complete-profile-invitation";
import { InvitationForm } from "../types/forms/invitation-form";
import { InvitationEntrepriseCheck } from "../types/models/invitation-entreprise";
import { HttpClient } from "./http-client";

export class InvitationEntrepriseService {
  private readonly http: HttpClient;

  constructor(apiUrl: string) {
    this.http = new HttpClient(apiUrl);
  }

  async getPendingInvitations(
    idEntreprise: number,
  ): Promise<InvitationEntrepriseCheck[]> {
    return this.http.get<InvitationEntrepriseCheck[]>(
      `/api/entreprises/${idEntreprise}/invitations`,
    );
  }

  async send(idEntreprise: number, data: InvitationForm): Promise<void> {
    await this.http.post(`/api/entreprises/${idEntreprise}/invitation`, data);
  }

  async resend(idEntreprise: number, idInvitation: string): Promise<void> {
    await this.http.post(
      `/api/entreprises/${idEntreprise}/invitation/${idInvitation}/resend`,
    );
  }

  async cancel(idEntreprise: number, idInvitation: string): Promise<void> {
    await this.http.delete(
      `/api/entreprises/${idEntreprise}/invitation/${idInvitation}`,
    );
  }

  async checkToken(token: string): Promise<InvitationEntrepriseCheck> {
    return this.http.get<InvitationEntrepriseCheck>(
      `/api/entreprises/invitation/${token}/check`,
    );
  }

  async accept(
    token: string,
    data: CompleteProfileInvitationForm,
  ): Promise<void> {
    await this.http.patch(`/api/entreprises/invitation/${token}/accept`, data);
  }

  async refuse(token: string): Promise<void> {
    await this.http.patch(`/api/entreprises/invitation/${token}/refuse`);
  }
}
